import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LayoutBaseComponent } from '@technocom/core';

@Component({
  selector: 'app-ui',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent extends LayoutBaseComponent {
  // empty
}
